import React,{useState,useEffect} from 'react'
import Logo from '../../images/logo.png';
import css from '../../css/header.module.css';
import {Link} from 'react-router-dom';
import {Box,Typography} from '@mui/material';
import {TfiBell as BellIcon} from 'react-icons/tfi';
import { convertTimetoString } from '../../helperFunction';

const NavBar = () => {
    const [currentDate,setCurrentDate] = useState<string | any>('19th February, 2023');

    useEffect(()=>{
      let d = new Date();
      let cTime = convertTimetoString(d,0);
      setCurrentDate(cTime); 
    },[])

    return (
      <Box component={"header"} className={css.container}>
        <Link to="/dashboard/overview" className={css.logo}>
          {<img src={Logo} alt="logo"/>}
          <span>CIPM Dashboard</span>
        </Link>
        <Typography component={"div"} className={css.navDiv} >
            <div className={css.notificationDiv}>
               <span><BellIcon/></span>
               <Typography component={"div"} className={css.notification}>
               </Typography>
            </div>
            <div>
              {currentDate?currentDate:''}
            </div>
        </Typography>
              
      </Box>
    )
  }
  
  export default NavBar;